import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { documentText } from 'ionicons/icons'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { setReportType } from '../store/specialReports.actions'
import { useTranslation } from 'react-i18next'

const SpecialReportButton: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const onSpecialReportClick = () => {
    dispatch(setReportType('pcr'))
    history.push(AppRouterConstants.SPECIAL_REPORTS_ROUTE)
  }

  return (
    <IonButton
      data-testid='SpecialReports'
      className='scan-drivers-license-button'
      expand='block'
      fill='clear'
      onClick={onSpecialReportClick}
      color='primary-alt'>
      <IonIcon icon={documentText} size='large' />
      {t('specialReports.specialReports')}
    </IonButton>
  )
}

export default SpecialReportButton
